import { gtmSendEvent } from "@wojo/analytics";
import { useI18n } from "@wojo/localization";
import { Button } from "@wojo/ui";
import React from "react";
import { FiSliders } from "react-icons/fi";
import {
    TripBuilderFeaturedFilter,
    useTourPageContext,
} from "../../../_client/context";
import { useDeparturesStepContext } from "../context/DeparturesStepContext";
import { DeparturePriceWithFlights } from "./DeparturePriceWithFlights";
import { DepartureHeaderFeaturedFilter } from "./DepartureHeaderFeaturedFilter";

export const DepartureHeaderActionBar: React.FC = () => {
    const { tourContent, pageConfig } = useTourPageContext();
    const { productPage } = useI18n("productPage");
    const { setIsFilterOpen } = useDeparturesStepContext();
    const startGatewayCode = tourContent.tour?.startGatewayCode;
    const endGatewayCode = tourContent.tour?.endGatewayCode;
    const showPriceWithFlightsFilter = !!startGatewayCode && !!endGatewayCode;

    return (
        <>
            <div style={{ width: "100%" }}>
                {showPriceWithFlightsFilter &&
                    pageConfig.tripBuilderFeaturedFilter ===
                        TripBuilderFeaturedFilter.PriceWithFlight && (
                        <DeparturePriceWithFlights />
                    )}

                {pageConfig.tripBuilderFeaturedFilter ===
                    TripBuilderFeaturedFilter.AvailableOnline && (
                    <DepartureHeaderFeaturedFilter
                        label={productPage.tripBuilder.filters.status.l()}
                        filterName="status"
                        filterType="Online Booking Dates"
                    />
                )}

                {pageConfig.tripBuilderFeaturedFilter ===
                    TripBuilderFeaturedFilter.DealsOnly && (
                    <DepartureHeaderFeaturedFilter
                        label={productPage.tripBuilder.filters.isOnSale.l()}
                        filterName="isOnSale"
                        filterType="Deals only"
                    />
                )}

                {pageConfig.tripBuilderFeaturedFilter ===
                    TripBuilderFeaturedFilter.ExtensionsOnly && (
                    <DepartureHeaderFeaturedFilter
                        label={productPage.tripBuilder.filters.hasExtensionAvailable.l()}
                        filterName="hasExtensionAvailable"
                        filterType="Extensions only"
                    />
                )}
            </div>
            <Button
                variant="quiet"
                adornLeft={<FiSliders aria-hidden />}
                onClick={() => {
                    gtmSendEvent({
                        event: "track",
                        ga4Tracking: {
                            ga4_object: "TRIP_BUILDER",
                            ga4_action: "OPEN_FILTERS",
                        },
                    });
                    setIsFilterOpen?.(true);
                }}
            >
                Filter
            </Button>
        </>
    );
};
